import { render } from "./ios-musical-notes.vue?vue&type=template&id=4991fad2"
import script from "./ios-musical-notes.vue?vue&type=script&lang=js"
export * from "./ios-musical-notes.vue?vue&type=script&lang=js"
script.render = render

export default script